import { useState } from 'react';
import HeroImage from './components/HeroImage';

import './css/App.css';
import { useDocumentTitle } from "./hooks/useDocumentTitle";

import { Hero07bcontact } from './Images.js';
import { PhotoSxsw } from './Images.js';
import { PhotoNup } from './Images.js';
import { PhotoNitro } from './Images.js';

import { useMediaQuery } from 'react-responsive';

function Contact() {
  useDocumentTitle("Contact");
  const isMobile = useMediaQuery({ query: `(max-width: 960px)` });

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const [statusMessage, setStatusMessage] = useState({ type: null, text: '' });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
    // Clear status message when user starts typing
    if (statusMessage.type) {
      setStatusMessage({ type: null, text: '' });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    try {
      // API endpoint from environment variable with fallback
      const apiEndpoint = process.env.REACT_APP_API_ENDPOINT || '/api/contact-email.php';
      
      const response = await fetch(apiEndpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });
  
      const data = await response.json();
  
      if (response.ok && data.success) {
        // Reset form on success
        setFormData({
          name: '',
          email: '',
          subject: '',
          message: ''
        });
        setStatusMessage({ type: 'success', text: data.message || 'Email sent successfully!' });
      } else {
        setStatusMessage({ type: 'error', text: data.error || 'Error sending email!' });
      }
    } catch (error) {
      console.error('Error sending email:', error);
      setStatusMessage({ type: 'error', text: 'Error sending email! Please try again later.' });
    }
  };

  return (
      <div className="sectionbody">
        <div className={isMobile ? "hero-image-area-mobile" : "hero-image-area"}>
            <HeroImage src={Hero07bcontact} alt="Contact Kate the Chemist" />
        </div>

        <div className={isMobile ? "intro-paragraph-area-mobile" : "intro-paragraph-area"}>
            <h1>Contact</h1>
            <p>
              For booking Kate the Chemist for your next event or show, please fill out the form below.
            </p>

            {statusMessage.type && (
              <div className={`form-message ${statusMessage.type === 'success' ? 'form-message-success' : 'form-message-error'}`}>
                {statusMessage.text}
              </div>
            )}

            <div className="form-container">
              <form onSubmit={handleSubmit}>
                <div>
                  <label htmlFor="contact-name" className="sr-only">Your name</label>
                  <input
                    id="contact-name"
                    type="text"
                    placeholder="Your name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div>
                  <label htmlFor="contact-email" className="sr-only">Email</label>
                  <input
                    id="contact-email"
                    type="email"
                    placeholder="Email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div>
                  <label htmlFor="contact-subject" className="sr-only">Subject</label>
                  <input
                    id="contact-subject"
                    type="text"
                    placeholder="Subject"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                  />
                </div>
                <div>
                  <label htmlFor="contact-message" className="sr-only">Your message</label>
                  <textarea
                    id="contact-message"
                    placeholder="Your message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div>
                  <button type="submit"> Contact Kate </button>
                </div>
              </form>
            </div>
            <h3>South Bend Indiana / Notre Dame Area</h3>
            <p>If you would like to volunteer with Kate the Chemist, please fill out <a href="https://forms.gle/nuKNQSEKdoAJJy5F7">this form</a>
              <br /><br />
              Enter the Kate the Chemist lottery via <a href="https://docs.google.com/forms/u/1/d/e/1FAIpQLSe0h59nhpK6WuxTijYzZwuIhwkw-Fv-HqCmV7MP404YZlFd-A/viewform?usp=send_form">this form</a>!
            </p>
        </div>

        <div className="blue-bg-area">
        <div className="about-img-container">
            <img className="about-gallery-img" src={ PhotoSxsw } alt="Kate the Chemist at SXSW" loading="lazy" />
            <img className="about-gallery-img" src={ PhotoNitro } alt="Kate the Chemist liquid nitrogen experiment" loading="lazy" />
            <img className="about-gallery-img" src={ PhotoNup } alt="Kate the Chemist on stage" loading="lazy" />
          </div>
        </div>

      </div>


  );
}

export default Contact;
